import React from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import ErrorBox from '../components/error-box';
export default class PasswordReset extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: undefined,
            success: undefined,
            token: undefined,
            password: undefined,
            confirmPassword: undefined
        };
    }
    componentDidMount() {
        const queryParams = new URLSearchParams(this.props.location.search);
        const token = queryParams.get('token');
        if (token == undefined) {
            this.setState({ error: PasswordReset.tokenMissingMessage });
        }
        else {
            this.setState({ token: token });
        }
    }
    handleChange(event) {
        const { name, value } = event.currentTarget;
        this.setState({
            [name]: value,
        });
    }
    async handleSubmit(event) {
        event.preventDefault();
        this.setState({ error: undefined });
        if (this.state.token == undefined) {
            this.setState({ error: PasswordReset.tokenMissingMessage });
            return;
        }
        if (this.state.password !== this.state.confirmPassword) {
            this.setState({ error: 'Passwords do not match' });
            return;
        }
        const requestData = {
            token: this.state.token,
            password: this.state.password
        };
        const res = await fetch('/api/users/password', {
            method: 'PUT',
            body: JSON.stringify(requestData),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const data = await res.json();
        if (data.error != undefined) {
            this.setState({ error: data.error });
        }
        else if (data.success === true) {
            this.setState({ success: true });
        }
        else {
            this.setState({ error: 'Unexpected result.' });
        }
    }
    render() {
        if (this.state.success) {
            return React.createElement(Redirect, { to: "/my-account.html" });
        }
        return (React.createElement("article", null,
            React.createElement("section", { className: "main-col" },
                React.createElement("h1", { className: "h2" }, "Forgotten password"),
                React.createElement("p", null,
                    "Please input the new password you want to set for your account. If your password reset token does not work, go back to the ",
                    React.createElement(Link, { to: "/forgotten-password.html" }, "forgotten password page"),
                    " to request a new link."),
                React.createElement(ErrorBox, { msg: this.state.error }),
                React.createElement("form", { onSubmit: e => this.handleSubmit(e) },
                    React.createElement("label", { htmlFor: "email" }, "New password"),
                    React.createElement("input", { name: "password", className: "form-control", type: "password", placeholder: "New password", required: true, onChange: e => this.handleChange(e) }),
                    React.createElement("label", { htmlFor: "email" }, "Confirm new password"),
                    React.createElement("input", { name: "confirmPassword", className: "form-control", type: "password", placeholder: "Confirm new password", required: true, onChange: e => this.handleChange(e) }),
                    React.createElement("input", { name: "token", id: "token", type: "hidden", value: this.state.token }),
                    React.createElement("div", { className: "buttons-container" },
                        React.createElement("input", { type: "submit", value: "Change password", className: "btn btn-primary" }))))));
    }
}
PasswordReset.tokenMissingMessage = 'Password reset token is missing. Make sure to follow the link from a password reset email!';
